function RestoreIcon() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4414_27631)">
        <path
          d="M3.87554 10.8333C4.08627 12.441 4.87572 13.9168 6.09611 14.9845C7.31649 16.0521 8.88413 16.6384 10.5056 16.6335C12.1271 16.6287 13.6912 16.033 14.9051 14.9581C16.1191 13.8832 16.8997 12.4027 17.1008 10.7938C17.302 9.18483 16.9098 7.55773 15.9978 6.21707C15.0857 4.87642 13.7164 3.9141 12.146 3.51028C10.5756 3.10645 8.9119 3.28879 7.46627 4.02317C6.02064 4.75754 4.8922 5.99361 4.2922 7.49999M3.87554 3.33332L3.87554 7.49999L8.04221 7.49999"
          stroke="#00A653"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4414_27631">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(-1 0 0 -1 20.5 20)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default RestoreIcon;
